import { render, staticRenderFns } from "./ProductDiscountsIcon.vue?vue&type=template&id=d05710a4"
import script from "./ProductDiscountsIcon.vue?vue&type=script&lang=js"
export * from "./ProductDiscountsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports